'use strict';

var _makeEnum;
var NOOP = function() {};

if (process.env.DEBUG === 'true') {
  _makeEnum = function makeEnum(obj) {
    if (
      !global.Proxy ||
      typeof global.Proxy.create === 'function' || // Old proxy, do not support
      typeof global.Proxy !== 'function' // No Proxy API
    ) {
      // No proxy support, return immediately.
      return obj;
    }

    return new global.Proxy(obj, {
      get: function(target, name) {
        if (!target.hasOwnProperty(name)) {
          throw new ReferenceError('Unknown enum value ' + name);
        }
        return target[name];
      },
      set: NOOP,
      delete: NOOP
    });
  };
} else {
  _makeEnum = function(obj) {
    return obj;
  };
}

module.exports = _makeEnum;
